module.exports = __webpack_public_path__ + "static/media/person04.084786c5.mp4";